import '@/assets/css/common.less'
import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import Viser from 'viser-vue'
import Antd from 'ant-design-vue'
import defultTheme from './config/theme'
import 'ant-design-vue/dist/antd.css'

Vue.use(Antd)
Vue.use(Viser)

Vue.config.productionTip = false

new Vue({
    router,
    store,
    created () {
        store.commit('setAppTheme', defultTheme)
    },
    render: h => h(App)
}).$mount('#app')
